"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _AuthCode = _interopRequireDefault(require("@/components/AuthCode/"));
var _firstLoginPassword = require("@/api/firstLoginPassword");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FirstLoginChangePasswordDialog',
  components: {
    AuthCode: _AuthCode.default
  },
  data: function data() {
    return {
      submitting: false,
      loginForm: {
        old_pwd: '',
        captche_num: '',
        cur_pwd: '',
        re_pwd: ''
      }
    };
  },
  computed: {
    rules: function rules() {
      var curPwdRules = [{
        required: true,
        message: '请输入新密码',
        trigger: 'blur'
      }, {
        min: 6,
        message: '新密码至少 6 位',
        trigger: 'blur'
      }];
      var rePwdRules = [{
        required: true,
        validator: this.sameAsNewPwd,
        trigger: 'blur'
      }];
      if (this.checkRoles(['terminal'])) {
        return {
          old_pwd: [{
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }],
          cur_pwd: curPwdRules,
          re_pwd: rePwdRules
        };
      }
      return {
        captche_num: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        cur_pwd: curPwdRules,
        re_pwd: rePwdRules
      };
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo || {};
    },
    dialogVisible: function dialogVisible() {
      return this.$store.getters.needForceChangePassword;
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.resetForm();
        this.$nextTick(function () {
          _this.$refs.form && _this.$refs.form.clearValidate();
        });
      }
    }
  },
  methods: {
    sameAsNewPwd: function sameAsNewPwd(rule, value, callback) {
      if (!value) {
        callback(new Error('请再次输入新密码'));
        return;
      }
      if (value !== this.loginForm.cur_pwd) {
        callback(new Error('两次输入的新密码不一致'));
        return;
      }
      callback();
    },
    resetForm: function resetForm() {
      this.loginForm = {
        old_pwd: '',
        captche_num: '',
        cur_pwd: '',
        re_pwd: ''
      };
    },
    getAuthCode: function getAuthCode() {
      if (!this.agentInfo.phone) {
        this.$message({
          message: '无法获取手机号',
          type: 'warning'
        });
        return;
      }
      this.$refs.authCode.getAuthCode({
        phone_num: this.agentInfo.phone,
        type: 7
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this2.submitting = true;
        var params = _objectSpread({}, _this2.loginForm);
        if (_this2.checkRoles(['terminal'])) {
          params.type = 0;
        }
        _this2.$post('agentapi/edit_password_save', params).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _t;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.$message({
                  message: '修改成功',
                  type: 'success'
                });
                _context.prev = 1;
                _context.next = 2;
                return (0, _firstLoginPassword.reportFirstLoginPasswordChanged)();
              case 2:
                _context.next = 4;
                break;
              case 3:
                _context.prev = 3;
                _t = _context["catch"](1);
              case 4:
                _this2.$store.commit('user/SET_NEED_FORCE_CHANGE_PASSWORD', false);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 3]]);
        }))).catch(function () {}).finally(function () {
          _this2.submitting = false;
        });
      });
    }
  }
};